var map = {
	"./aboutme/aboutme.json": 620,
	"./acrylics/acrylics.json": 578,
	"./mainMosaicMenu/mainMosaicMenu.json": 15,
	"./oils/oils.json": 213,
	"./restoration/restoration.json": 253,
	"./sacredart/sacredart.json": 577,
	"./watercolors/watercolors.json": 971,
	"./woodburning/woodburning.json": 881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;